import React from 'react';
import { ItemDivider } from 'components/MenuList';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ComboBoxMenuItemDivider() {
  return /*#__PURE__*/_jsx(ItemDivider, {
    as: "li"
  });
}